import { Button } from "flowbite-react";
import { toAbsoluteMediaUrl } from "./propertyMediaHelpers";

export default function PropertyMediaSavedGrid({
  deletingId,
  emptyLabel = "—",
  imageHeightClass = "h-40",
  items,
  onDelete,
  onView,
  sectionTitle,
  typeLabel,
  viewButtonLabel,
}) {
  if (!items.length) return null;

  return (
    <div className="space-y-2">
      <div className="text-sm font-medium text-gray-900 dark:text-white">
        {sectionTitle}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {items.map((item) => (
          <div
            key={item.id}
            className="border border-gray-200 dark:border-gray-800 rounded-lg p-3 bg-white dark:bg-gray-900"
          >
            <img
              src={toAbsoluteMediaUrl(item.url)}
              alt={item.label || typeLabel}
              className={`w-full ${imageHeightClass} object-cover rounded-md`}
            />

        <div className="mt-2 flex items-center justify-between gap-2">
          <div className="text-xs text-gray-600 dark:text-gray-300 truncate">
            {item.label || emptyLabel}
          </div>

          <div className="flex items-center gap-2">
            {onView && (
              <Button
                color="gray"
                size="xs"
                onClick={() => onView(item)}
              >
                {viewButtonLabel || "Ver"}
              </Button>
            )}
            <Button
              color="failure"
              size="xs"
              disabled={deletingId === item.id}
              onClick={() => onDelete(item.id)}
            >
              {deletingId === item.id ? "Excluindo..." : "Excluir"}
            </Button>
          </div>
        </div>
      </div>
    ))}
  </div>
    </div>
  );
}
